module.exports = __webpack_public_path__ + "static/media/en.e5564902.svg";